import * as Yup from 'yup';
import { emailRegEx, phoneRegEx, zipCodeRegEx } from '@/utils/RegularExpressions';
import { States } from '../../../../../constants';

export const validStateOptions: string[] = States.map((state) => state.name);

const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string().required('Required').max(250, 'Must be less than 250 characters.'),
    contactEmail: Yup.string().required('Required').matches(emailRegEx, 'Please enter a valid email address'),
  }),
});

const step1Schema = Yup.object({
  application: Yup.object({
    name: Yup.string().required('Required').min(4, 'It must be greater than 4 character'),
    streetAddress: Yup.string().required('Required').min(4, 'It must be greater than 4 character'),
    city: Yup.string().required('Required').min(2, 'It must be greater than 2 character'),
    state: Yup.string().required('Required').oneOf(validStateOptions, 'Invalid option'),
    zipCode: Yup.string()
      .typeError('Must be a number')
      .required('Required')
      .matches(zipCodeRegEx, 'It must be 5 digits')
      .max(5, 'It must be 5 digits')
      .min(5, 'It must be 5 digits'),
    phone: Yup.string().matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
    neighborhood: Yup.string().required('Required'),
    dob: Yup.string().required('Required'),
    gender: Yup.string().required('Required'),
    maritalStatus: Yup.string().required('Required'),
    disabled: Yup.string().required('Required'),
    hasAssets: Yup.string().required('Required'),
    receivedAssistance: Yup.string().required('Required'),
    race: Yup.array().min(1, 'Required'),
    doChildrenLive: Yup.string().required('Required'),
    requestedInsurance: Yup.string().required('Required'),
    wasBuiltBefore1978: Yup.string().required('Required'),
    femaleHeadOfHousehold: Yup.string().required('Required'),
  }),
});

const step2Schema = Yup.object({
  householdIncome: Yup.array(),
});

const step3Schema = Yup.object({
  scope: Yup.object({
    roofing: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
    plumbing: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
    electrical: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
    heatAndAir: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
    structural: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
    painting: Yup.boolean()
      .typeError('')
      .nullable()
      .transform((_, val) => !!val),
  }),
});

export const CRValidationSchema = [defaultStepsSchema, step1Schema, step2Schema, step3Schema];
